import type { BotStats } from "@investhinks/api-client";
import type { TFunction } from "i18next";
import React from "react";
import { Card, CardBody, CardHeader } from "reactstrap";

import { LegalFooter } from "../../../../../components/legal";

interface TotalMovements {
  deposit?: number;
  withdrawal?: number;
}

interface ActivitySidebarProps {
  stats?: BotStats;
  symbol?: string;
  totalMovements?: TotalMovements;
  openAccountMovementsModal?: () => void;
  t: TFunction;
}

const ActivitySidebar: React.FC<ActivitySidebarProps> = ({
  stats,
  symbol,
  totalMovements,
  openAccountMovementsModal,
  t,
}) => {
  return (
    <Card className="mb-2 card-hover">
      <CardHeader className="py-2 bg-transparent">
        <h6 className="mb-0 text-uppercase text-muted" style={{ fontSize: "0.7rem" }}>
          <i className="fas fa-exchange-alt mr-2" />
          {t("sidebar.activity")}
        </h6>
      </CardHeader>
      <CardBody className="pt-0 pb-2">
        <div className="d-flex justify-content-between align-items-center py-1 stat-row border-bottom">
          <small className="text-muted">{t("sidebar.openTrades")}</small>
          <span className="font-weight-bold">{stats?.openTrades || "0"}</span>
        </div>
        <div className="d-flex justify-content-between align-items-center py-1 stat-row border-bottom">
          <small className="text-muted">{t("sidebar.totalTrades")}</small>
          <span className="font-weight-bold">{stats?.trades || "0"}</span>
        </div>
        <div className="d-flex justify-content-between align-items-center py-1 stat-row border-bottom">
          <small className="text-muted">{t("sidebar.expectedProfit")}</small>
          <span className="font-weight-bold">
            {stats?.expected_profit != null && stats?.balance
              ? ((stats.expected_profit / stats.balance) * 100).toFixed(2)
              : "---"}
            %
          </span>
        </div>
        <div
          className="d-flex justify-content-between align-items-center py-1 stat-row stat-clickable border-bottom"
          onClick={openAccountMovementsModal}
        >
          <small className="text-muted">
            {t("sidebar.deposits")}
            <i className="fas fa-external-link-alt ml-2 text-primary" style={{ fontSize: "0.7em" }} />
          </small>
          <span className="font-weight-bold">
            {totalMovements?.deposit ? `+${totalMovements.deposit.toFixed(2)}` : "0.00"} {symbol}
          </span>
        </div>
        <div
          className="d-flex justify-content-between align-items-center py-1 stat-row stat-clickable"
          onClick={openAccountMovementsModal}
        >
          <small className="text-muted">
            {t("sidebar.withdrawals")}
            <i className="fas fa-external-link-alt ml-2 text-primary" style={{ fontSize: "0.7em" }} />
          </small>
          <span className="font-weight-bold">
            {totalMovements?.withdrawal ? `-${totalMovements.withdrawal.toFixed(2)}` : "0.00"} {symbol}
          </span>
        </div>
        <LegalFooter type="broker" />
      </CardBody>
    </Card>
  );
};

export default ActivitySidebar;
